import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";
import AnalyzerRow from "./AnalyzerRow";
import {custom} from "../../utils/linker";
import ImportResult from "./ImportResult";

function AnalyzerView(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore=useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);


  return (
    <div className="pbottom20">
      <div className="pbottom20">
        <div className="up12 margin">
          <div className="cell s-auto">
            <h2>Соедините колонки CSV с колонками категории</h2>
          </div>
          <div className="cell s-shrink s-top">
            <span className="fs32 mdi mdi-close b1 pointer" onClick={()=>{ compStore.closeImport(); }}></span>
          </div>
        </div>
      </div>
      <div className="solid1-bottom bo-w2 pbottom10 mbottom10 ">
        <div className="up12 margin fs14">
          <div className="cell s-6">Колонка в CSV-файле</div>
          <div className="cell s-3">Использовать в качестве индекса?</div>
          <div className="cell s-3">Поле категории</div>
        </div>
      </div>

      {compStore.analyze.data.map((item, index)=>{
        return (
          <div className="solid1-bottom bo-w2" key={index}>
            <AnalyzerRow {...custom(compStore.analyze.data, index)}/>
          </div>
        )
      })}

      <div className="ptop20">
        <div className="up12 margin">
          <div className="cell s-auto"></div>
          <div className="cell s-shrink">
            <ImportResult />
          </div>
          <div className="cell s-shrink">
            <span className="btn2" onClick={()=>{
              runInAction(()=>{
                compStore.deleteTmpFile();
                compStore.analyze.data=null;
                compStore.analyze.inited=false;
                compStore.mapper={};
                compStore.data.tmp_file=null;
              });
            }}><span>Загрузить другой файл</span></span>
          </div>

          <div className="cell s-shrink">
            <span className={`btn1 ${compStore.submitting?"btnLoading":""}`} onClick={()=>{ compStore.startImport(); }}><span>Имортировать</span></span>
          </div>
        </div>
      </div>
    </div>
  )
};

AnalyzerView.defaultProps = {};

AnalyzerView.propTypes = {}

export default observer(AnalyzerView);
